import { NODE_TYPES } from '@services/conditionEngine/constants';
import countEvaluator, { COUNT_OPERATIONS } from '@services/conditionEngine/evaluators/count';
import evaluatorRegistry from '@services/conditionEngine/evaluators/registry';

function andEvaluator(node, values) {
  const countConditionNode = {
    ...node,
    op: COUNT_OPERATIONS.EQUAL,
    compare_to: node.children.length
  };

  return countEvaluator(countConditionNode, values);
}

evaluatorRegistry.registerEvaluatorForNodeType(NODE_TYPES.AND, andEvaluator);
export default andEvaluator;
